<template>
  <div class="card color-selection">
    <div class="card-header large">
      <img :src="getIcon('settings.svg')" alt="" />
      <p class="heading">
        {{ $t('BrandColor.filter_color') }}
      </p>
    </div>
    <div class="card-content">
      <div class="color-list">
        <transition-group name="fade" tag="div" class="colors">
          <ColorSelectionItem
            v-for="color in singleTypeColors"
            :key="color.id"
            :color="color"
          />
        </transition-group>

        <template v-if="doubleTypeColors.length">
          <div
            class="show-combinations"
            :class="{ active: showDoubleTypeColors }"
          >
            <img class="arrow-down" :src="getIcon('triangle.svg')" />
            <span @click="showDoubleTypeColors = !showDoubleTypeColors">
              {{ $t('ColorList.color_combinations') }}
            </span>
          </div>

          <fade-transition>
            <template v-if="showDoubleTypeColors">
              <transition-group
                name="fade"
                tag="div"
                class="colors combinations"
              >
                <ColorSelectionItem
                  v-for="color in doubleTypeColors"
                  :key="color.id"
                  :color="color"
                />
              </transition-group>
            </template>
          </fade-transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ColorSelectionItem from './ColorSelectionItem';
import FadeTransition from '../transitions/FadeTransition';

export default {
  name: 'ColorSelection',
  components: {
    FadeTransition,
    ColorSelectionItem,
  },
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDoubleTypeColors: false,
    };
  },
  computed: {
    singleTypeColors() {
      return this.colors.filter((color) => color.type === 'single');
    },
    doubleTypeColors() {
      return this.colors.filter((color) => color.type === 'double');
    },
  },
};
</script>
